import ModalV2 from "../ModalV2";
import PropTypes from "prop-types";
import { CheckCircle, RefreshCw, CreditCard } from "lucide-react";

export default function RampEventModal({ name = "rampEventModal", session }) {
  const events = [...(session?.events || [])].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  ); // Orden descendente: más recientes primero

  const formatDateTime = (dateString) =>
    new Date(dateString).toLocaleString();

  const getEventMeta = (event) => {
    switch (event.type) {
      case "ramp_session_started":
        return {
          description: "The user started the session",
          icon: <CheckCircle className="w-5 h-5 text-green-500" />,
        };
      case "contract_updated":
        return {
          description: `The user selected the contract: ${event.data?.contractName || event.data?.contractId || "N/A"}`,
          icon: <CreditCard className="w-5 h-5 text-blue-500" />,
        };
      case "type_updated":
        return {
          description: event.data?.previousType
            ? `The user changed the type from ${event.data.previousType} to ${event.data.type}`
            : `The user changed the type to: ${event.data?.type || "N/A"}`,
          icon: <RefreshCw className="w-5 h-5 text-yellow-500" />,
        };
      default:
        return {
          description: "Unknown action",
          icon: null,
        };
    }
  };

  return (
    <ModalV2
      name={name}
      title="Ramp Session Events"
      className="w-full max-w-2xl"
    >
      <div className="mt-4 max-h-[70vh] overflow-y-auto">
        {events.length === 0 && (
          <p className="text-gray-500 text-sm">
            No events have been recorded for this session.
          </p>
        )}

        {/* Label indicating the order of the history */}
        {events.length > 0 && (
          <p className="text-gray-500 text-sm mb-2">
            Event history (most recent first)
          </p>
        )}
        <div className="space-y-4">
          {events.map((event, index) => {
            const meta = getEventMeta(event);
            return (
              <div key={event.id} className="border border-zinc-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-gray-500">{index + 1}.</span>
                    {meta.icon}
                    <h3 className="text-md font-semibold text-gray-800 capitalize">
                      {event.type.replace(/_/g, " ")}
                    </h3>
                  </div>
                  <span className="text-xs text-gray-500">
                    {formatDateTime(event.createdAt)}
                  </span>
                </div>

                <p className="text-sm text-gray-700 mb-1">{meta.description}</p>

                <p className="text-xs text-gray-500">
                  <strong>Event ID:</strong> {event.id}
                </p>
                <p className="text-xs text-gray-500">
                  <strong>Session ID:</strong> {event.sessionId}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </ModalV2>
  );
}

RampEventModal.propTypes = {
  name: PropTypes.string,
  session: PropTypes.shape({
    events: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        sessionId: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        createdAt: PropTypes.string.isRequired,
        updatedAt: PropTypes.string,
        data: PropTypes.object,
      })
    ),
  }),
};
